export type PagedPathResult = {
  browserPath: string
  canonicalPath: string
  pageNum: number
  redirectTo: string
}

const normalizePath = (value: string): string => {
  const raw = String(value || '').trim()
  if (!raw || raw === '/') return '/'

  const withoutHash = raw.split('#')[0] || ''
  const withoutQuery = withoutHash.split('?')[0] || ''
  const prefixed = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`
  const normalized = prefixed.replace(/\/+/g, '/').replace(/\/+$/g, '')
  return normalized || '/'
}

export const parsePagedPath = (path: string): PagedPathResult => {
  const browserPath = normalizePath(path)
  const segments = browserPath.split('/').filter(Boolean)

  if (segments.length >= 2) {
    const pageMarker = segments[segments.length - 2]
    const pageValue = segments[segments.length - 1]
    const matchedPage = /^\d+$/.test(pageValue || '')

    if (pageMarker === 'page' && matchedPage) {
      const parsedPage = Number.parseInt(pageValue, 10)
      const canonicalSegments = segments.slice(0, -2)
      const canonicalPath = canonicalSegments.length ? `/${canonicalSegments.join('/')}` : '/'
      const pageNum = Number.isFinite(parsedPage) && parsedPage > 0 ? parsedPage : 1

      return {
        browserPath,
        canonicalPath,
        pageNum,
        redirectTo: pageNum <= 1 ? canonicalPath : '',
      }
    }
  }

  return {
    browserPath,
    canonicalPath: browserPath,
    pageNum: 1,
    redirectTo: '',
  }
}

export const buildPagedPath = (canonicalPath: string, pageNum: number): string => {
  const basePath = normalizePath(canonicalPath)
  const normalizedPage = Number.isFinite(pageNum) ? Math.max(1, Math.floor(pageNum)) : 1
  if (normalizedPage <= 1) return basePath
  return `${basePath === '/' ? '' : basePath}/page/${normalizedPage}`
}